function ServerError(message) {
  this.name = "ServerError";
  this.message = message || "";
  this.stack = new Error().stack;
}
ServerError.prototype = Object.create(Error.prototype);
ServerError.prototype.constructor = ServerError;

export default ServerError;
